import { PanelLeftClose, PanelRightClose } from 'lucide-react';
import cn from 'classnames';
import Logo from '@/assets/logo_d.svg?react';
import LogoS from '@/assets/logo_sq.svg?react';
import useStore from '@/stores/sider-menu';

export default function LogoBar() {
  const { collapsed, toggleCollapsed } = useStore();

  return (
    <div className={cn(collapsed ? 'px-3' : 'px-5 pr-4', ' flex items-center justify-between group h-7')}>
      {collapsed ? (
        <div className="group-hover:hidden p-1">
          <LogoS style={{ width: 20, height: 20 }} />
        </div>
      ) : (
        <Logo />
      )}
      <div
        className={cn(
          collapsed ? 'hidden group-hover:block' : '',
          'cursor-pointer p-1 hover:bg-[#E5E5E5]/45 rounded transition'
        )}
        onClick={toggleCollapsed}
      >
        {collapsed ? (
          <PanelRightClose className="" size={20} color="#737373" strokeWidth={1.5} />
        ) : (
          <PanelLeftClose size={20} color="#737373" strokeWidth={1.5} />
        )}
      </div>
    </div>
  );
}
